export default "__VITE_ASSET__NXj2iTe5__"